import { render, staticRenderFns } from "./AsideLogo.vue?vue&type=template&id=ef205986&scoped=true&"
import script from "./AsideLogo.vue?vue&type=script&lang=js&"
export * from "./AsideLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef205986",
  null
  
)

export default component.exports